import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DateAdapter,
  MatNativeDateModule,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import { RouterModule } from '@angular/router';
// xplat
import { MdCoreModule } from '@macs-frontend/web';
import { SharedModule } from '@macs-frontend/web-macs/shared/shared.module';
import { AppDateAdapter, APP_DATE_FORMATS } from './adapters/date.adapter';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { ModuleSwitcherComponent } from './components/module-switcher/module-switcher.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { RootComponent } from './components/root/root.component';
import { AppComponent } from './containers/app/app.component';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';

@NgModule({
  imports: [CommonModule, MdCoreModule, RouterModule, MatNativeDateModule, SharedModule],
  declarations: [
    AppComponent,
    ModuleSwitcherComponent,
    NotificationsComponent,
    RootComponent,
    AccessDeniedComponent,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS,
    },
    CurrencyPipe,
    CanDeactivateGuard,
  ],
  exports: [
    AppComponent,
    ModuleSwitcherComponent,
    NotificationsComponent,
    AccessDeniedComponent,
  ],
})
export class CoreModule {}
